import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";
import { Badge } from "@/components/ui/badge";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { toast } from "sonner";
import { Factory, Plus } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

export default function Manufacturers() {
  const { hasRole } = useAuth();
  const [items, setItems] = useState([]);
  const [dlg, setDlg] = useState(false);
  const [form, setForm] = useState({ name: "", active: true, divisions: [], website: "", email: "", phone: "", requires_rma: true, customer_approval_required: true });
  const [divs, setDivs] = useState([]);

  const load = async () => {
    const [m, d] = await Promise.all([api.get("/manufacturers"), api.get("/divisions")]);
    setItems(m.data); setDivs(d.data);
  };
  useEffect(() => { load(); }, []);

  const save = async () => {
    try { await api.post("/manufacturers", form); toast.success("Produttore creato"); setDlg(false); load(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Errore"); }
  };

  const toggleActive = async (m) => {
    try { await api.patch(`/manufacturers/${m.id}`, { ...m, active: !m.active }); load(); }
    catch (e) { toast.error("Errore"); }
  };

  const toggleDiv = (d) => setForm((f) => ({ ...f, divisions: f.divisions.includes(d) ? f.divisions.filter((x) => x !== d) : [...f.divisions, d] }));

  return (
    <div className="p-4 md:p-8 max-w-6xl mx-auto" data-testid="manufacturers-page">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h1 className="text-3xl md:text-4xl font-heading font-bold text-[#0a0a2e]">Produttori</h1>
          <p className="text-slate-500">Anagrafica produttori e brand distribuiti da AMA Sicurezza.</p>
        </div>
        {hasRole("administrator") && <Button data-testid="add-manufacturer-btn" onClick={() => setDlg(true)} className="ama-btn-primary rounded-full"><Plus className="w-4 h-4 mr-1" /> Nuovo</Button>}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {items.map((m) => (
          <div key={m.id} className={`ama-card p-4 flex items-start gap-3 ${!m.active ? "opacity-60" : ""}`} data-testid={`manufacturer-${m.name}`}>
            <div className="w-10 h-10 rounded-lg bg-fuchsia-50 flex items-center justify-center text-[#d63384]"><Factory className="w-4 h-4" /></div>
            <div className="flex-1">
              <div className="flex items-center gap-2">
                <div className="font-semibold text-[#0a0a2e]">{m.name}</div>
                {!m.active && <Badge variant="outline" className="text-xs">Inattivo</Badge>}
              </div>
              <div className="flex flex-wrap gap-1 mt-1">
                {m.divisions?.map((d) => <span key={d} className="text-[10px] uppercase tracking-wider bg-slate-100 text-slate-600 rounded-full px-2 py-0.5">{d}</span>)}
              </div>
            </div>
            {hasRole("administrator") && (
              <Switch data-testid={`manufacturer-toggle-${m.name}`} checked={m.active} onCheckedChange={() => toggleActive(m)} />
            )}
          </div>
        ))}
      </div>

      <Dialog open={dlg} onOpenChange={setDlg}>
        <DialogContent className="max-w-lg">
          <DialogHeader><DialogTitle>Nuovo produttore</DialogTitle></DialogHeader>
          <div className="space-y-3">
            <div><Label>Nome</Label><Input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} /></div>
            <div>
              <Label className="mb-2 block">Divisioni</Label>
              <div className="flex flex-wrap gap-1.5">
                {divs.map((d) => {
                  const on = form.divisions.includes(d.name);
                  return <button key={d.id} type="button" onClick={() => toggleDiv(d.name)} className={`text-xs px-2.5 py-1 rounded-full border ${on ? "bg-[#0a0a2e] text-white border-transparent" : "bg-white text-slate-600 border-slate-200"}`}>{d.name}</button>;
                })}
              </div>
            </div>
            <div className="grid grid-cols-2 gap-2">
              <div><Label>Email</Label><Input value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} /></div>
              <div><Label>Telefono</Label><Input value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} /></div>
              <div className="col-span-2"><Label>Sito web</Label><Input value={form.website} onChange={(e) => setForm({ ...form, website: e.target.value })} /></div>
            </div>
            <div className="flex justify-end gap-2"><Button variant="outline" onClick={() => setDlg(false)}>Annulla</Button><Button className="ama-btn-primary" onClick={save}>Crea</Button></div>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
}
